import React, { useState, useEffect, CSSProperties } from 'react';
import { withStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Dialog from '@material-ui/core/Dialog';
import { connect } from 'react-redux';
import MembershipPremium from "../MembershipsCards/MembershipPremium";
import MembershipPremiumPlus from "../MembershipsCards/MembershipPremiumPlus";
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Lottie from 'lottie-react-web';
import Home from "../../animations/home/Home.json";
import Profile from "../../animations/profile/Perfil.json";
import Analytics from "../../animations/analytics/ANALITYCS.json";
import Membership from "../../animations/membership/MEMBRESIAS.json";
import Messages from "../../animations/messages/MENSAJES.json";
import Opinions from "../../animations/opinions/OPINIONES.json";
import Logros from "../../animations/logros/LOGROS.json";
import Photos from "../../animations/photo/FOTO_PERFIL.json";
import { closeModalTutorial } from "../../store/actions/ModalsActions";
import ButtonBase from "../Buttons/ButtonBase";
import {
    isBrowser,
    isMobile,
    MobileView,
    BrowserView,
} from 'react-device-detect';

import SwipeableViews from 'react-swipeable-views';

let iconClose = "/img/tache-white.svg"
let iconLeft = "/img/arrow-left.svg"
let iconRight = "/img/arrow-right.svg"

const useStyles = makeStyles({
    root: {
        boxShadow: 'none',
        backgroundColor: 'transparent'
    },
    paper: {
        display: 'flex',
        flexDirection: 'Column',
        width: "100%",
        height: "auto",
    },
    close: {
        display: 'flex',
        justifyContent: 'flex-end',
        cursor: 'pointer'

    }

});

let arrayCarroucelData = [
    { animation: Home, textOne: "Consulta de manera rápida y precisa", textTwo: "Consulta fácilmente el resumen de tu información y comportamiento dentro de la plataforma, puedes navegar de manera inmediata y ver estadísticas e información relevante para mejor tus resultados.", index: 0 },
    { animation: Profile, textOne: "Edita todo lo relacionado con tu perfil profesional.", textTwo: "Recuerda que una buena imagen habla por si sola. Aquí podrás editar todo lo relacionado a tu perfil y personalizarlo con tu información profesional.", index: 1 },
    { animation: Analytics, textOne: "Consulta las estadísticas de tu desempeño.", textTwo: "Es importante conocer el estatus del desempeño en la plataforma para poder planificar o mantener estrategias que alcancen un mayor número de prospectos.", index: 2 },
    { animation: Membership, textOne: "Adquiérela y consigue más clientes", textTwo: "Elige la membresía que se ajuste a tus necesidades y descubre todos los beneficios que tenemos para ti, cada una de las membresías tiene diferentes características que te permitirán llegar a más clientes en todo el país.", index: 3 },
    { animation: Messages, textOne: "Gestiona los mensajes que recibes en la plataforma.", textTwo: "Tienes control de los mensajes que recibas de nuevos clientes, se encuentran en tu bandeja de entrada y puedes guardar a tus contactos para un mejor control de tu información.", index: 4 },
    { animation: Opinions, textOne: "Recibe opiniones como testimoniales para tu perfil.", textTwo: "Puedes recibir calificaciones y comentarios de tus clientes por tus servicios, de esta manera obtienes retroalimentación. Selecciona las opiniones que quieres que se muestren en tu perfil.", index: 5 },
    { animation: Logros, textOne: "Entre más logros obtengas tu perfil estara más completo.", textTwo: "Obtén logros por cada dato que agregues a tu perfil o por tareas adicionales.", index: 6 },
    { animation: Photos, textOne: "Recomendación para una foto adecuada.", textTwo: "Sigue nuestras recomendaciones al elegir tu foto de perfil, ya que esta hará que transmitas confianza y más personas quieran contactarte.", index: 7 },
]

function ModalTutorial(props) {
    let { modalTutorial, closeModalTutorial } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(modalTutorial.numerTutorial);

    useEffect(() => {
console.log(classes)
    }, [modalTutorial]);

    const [index, setIndex] = useState(0);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const handleCloseModaleTutorial = () => {
        closeModalTutorial(false, 0)

    }

    const handleNextTutorial = () => {
        let next = modalTutorial.numerTutorial;
        if (modalTutorial.numerTutorial === 7) {
            next = 0
        } else {
            next = next + 1;
        }
        closeModalTutorial(true, next)
    }

    const handleBackTutorial = () => {
        let back = modalTutorial.numerTutorial - 1
        closeModalTutorial(true, back)
    }


    const getConfigurableProps = () => ({
        infiniteLoop: false,
        swipeable: true,
        dynamicHeight: false,
        emulateTouch: true,
        showStatus: false,
        centerMode: false,
        showArrows: false,
        showThumbs: false,
        showIndicators: false,
        stopOnHover: true,
        selectedItem: modalTutorial.numerTutorial
    });

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    // const getConfigurableProps = () => ({
    //     showArrows: true,
    //     showStatus: true,
    //     showIndicators: true,
    //     infiniteLoop: true,
    //     showThumbs: true,
    //     useKeyboardArrows: true,
    //     autoPlay: true,
    //     stopOnHover: true,
    //     swipeable: true,
    //     dynamicHeight: true,
    //     emulateTouch: true,
    //     thumbWidth: 100,
    //     selectedItem: 0,
    //     interval: 3000,
    //     transitionTime: 150,
    //     swipeScrollTolerance: 5,
    //     selectedItem: modalTutorial.numerTutorial
    // });

    const handleStepChange = step => {
        console.log('step ', step);
        setActiveStep(step);
    };
    return (
        <Dialog
        PaperProps={{
            classes: {
                root: classes.root 
              },
          }}
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            maxWidth={false}
            
            disableBackdropClick={modalTutorial.open}
            disableEscapeKeyDown={modalTutorial.open}
            open={modalTutorial.open}
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            fullScreen={isMobile ? true : false}
        >
            <div className="hide-table-end">
                <div className={classes.paper}>
                    <div className="contentMainTutorialData">
                        <div onClick={() => handleBackTutorial()} className="contentImgArrow arrowSeparationLeft hideMobile">
                            <img className="contentAnimationData" src={iconRight} alt="left" />
                        </div>
                        <div>
                            <div className="contentCloseData hideMobile">
                                <img onClick={() => handleCloseModaleTutorial()} className="imgClose" src={iconClose} alt="close" />
                            </div>
                            <Carousel
                                className="containerDataModalTutorial"
                                {...getConfigurableProps()}>

                                {arrayCarroucelData.map((data, index) => {
                                    return (
                                        <div key={index} className="contentAnimationData">
                                            <div className="contentAnimateLottie">
                                                <Lottie
                                                    options={{
                                                        animationData: data.animation,
                                                        loop: true,
                                                        autoplay: true,
                                                    }}
                                                />
                                            </div>
                                            <div className="contentInfoModal">
                                                <p className="titleInfoTutorial"> {data.textOne} </p>
                                                <p className="subTitleInfoTutorial"> {data.textTwo} </p>
                                                <div className="contentButtonNextOmitir">
                                                    <ButtonBase variant="primaryOutlined" onClick={() => handleCloseModaleTutorial()} className="buttonSkip">
                                                        Omitir</ButtonBase>
                                                    <ButtonBase onClick={() => handleNextTutorial()} variant="primary">
                                                        Siguiente</ButtonBase>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                            </Carousel>
                        </div>
                        <div onClick={() => handleNextTutorial()} className="contentImgArrow arrowSeparationRigth hideMobile">
                            <img className="contentAnimationData" src={iconLeft} alt="rigth" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="hide-break-desktop-small">
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={modalTutorial.numerTutorial}
                    onChangeIndex={handleNextTutorial}
                    enableMouseEvents
                >
                    {arrayCarroucelData.map((data, index) => {
                        return (
                            <div key={index} className="contentAnimationData">
                                <div className="contentAnimateLottie">
                                    <Lottie
                                        options={{
                                            animationData: data.animation,
                                            loop: true,
                                            autoplay: true,
                                        }}
                                    />
                                </div>
                                <div className="contentInfoModal">
                                    <div>
                                        <p className="titleInfoTutorial"> {data.textOne} </p>
                                        <p className="subTitleInfoTutorial"> {data.textTwo} </p>
                                    </div>
                                    <div className="contentButtonNextOmitir">
                                        <div>
                                            <ButtonBase variant="primaryOutlined" onClick={() => handleCloseModaleTutorial()} className="buttonSkip">
                                                Omitir</ButtonBase>
                                        </div>
                                        <div className="content-button-next">
                                            <ButtonBase onClick={() => handleNextTutorial()} variant="primary">
                                                Siguiente</ButtonBase>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                </SwipeableViews>
            </div>
        </Dialog>
    )

}

const mapDispatchToProps = dispatch => ({
    closeModalTutorial: (open, numerTutorial) => dispatch(closeModalTutorial(open, numerTutorial)),
})

const mapStateToProps = (state) => ({
    modalTutorial: state.ModalReducer.modalTutorial
});


export default connect(mapStateToProps, mapDispatchToProps)(ModalTutorial);